export const posts = [
  {
    url: 'https://www.linkedin.com/posts/joaqu%C3%ADn-sateler-villanueva_el-fin-de-semana-particip%C3%A9-en-mi-primera-activity-7268296731744731136-Wx7q?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:36:32.787Z',
    postData: {
      authorName: 'Joaquín Sateler Villanueva',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQEP7NfhzdJ84g/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1671031887083?e=2147483647&v=beta&t=iD-o8bGvf6Y-3ZCz55_bU1zDrEH1mkda3LqPUscEkEM',
      authorProfileUrl:
        'https://cl.linkedin.com/in/joaqu%C3%ADn-sateler-villanueva?trk=public_post_feed-actor-image',
      authorJobTitle: 'Experiencia de Usuario (UX) | Tecnología | Psicología',
      timePosted: '9mo',
      postContent:
        'El fin de semana participé en mi primera hackathon, Platanus hack, organizada por Platanus en las oficinas de Fintual. Fue la primera vez que me pongo a prueba así, y aunque me queda mucho por aprender, fue una tremenda oportunidad y estoy muy feliz por haberme lanzado a participar.\n\nLa idea del evento, como dice su slogan: "De 0 a producto en 36 horas", era crear un producto desde cero durante el fin de semana que resuelva un problema claro y presentarlo ante los jueces.\n\nMe voy muy contento con lo que logramos, con el esfuerzo que puse y con las personas que conocí. Pero más que cualquier otra cosa, muy agradecido con el tremendo equipo que trabajé, puras máquinas 🔥🔥!  Daniel Carrasco, 🚀Francisco Cordero, alex dannenberg y Daniel Sateler Israel',
      reactionsCount: 30,
      commentsCount: 2,
      comments: [
        {
          authorName: 'Sergio Pinedo Valdés',
          text: 'Agree & Join LinkedIn',
          reactions: 2,
        },
        {
          authorName: 'Francisco Cordero',
          text: 'Agree & Join LinkedIn',
          reactions: 2,
        },
      ],
      totalVisibleComments: 2,
      postImages: [],
      totalPostImages: 0,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [],
    },
    directoryName:
      'joaqun_sateler_villanueva_el_fin_de_semana_particip_en_mi_primera_hackathon_2025-08-26T19-36-32-789Z',
  },
  {
    url: 'https://www.linkedin.com/posts/activity-7267665470453960705-BNB6?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:36:50.723Z',
    postData: {
      authorName: 'Nicolás Berrios',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQG8TJ2g3C5GDw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1701469568099?e=2147483647&v=beta&t=tNC_2VBpTa3-XU0K_9pqIV0fpxP-1zLKhE_BhNifkuE',
      authorProfileUrl:
        'https://cl.linkedin.com/in/%7Eberrios?trk=public_post_feed-actor-image',
      authorJobTitle: 'CS @ Tech, Harvard REU ’23',
      timePosted: '9mo',
      postContent:
        'We built a security product in 36 hours and won the largest hackathon in Chile!\n\nWith a 1-line install, our system detects anomalies in web traffic, such as a user sporadically ignoring an endpoint, and blocks attackers in real-time.\n\nYou can catch me attempting to hack one of the sponsors and making up startup buzzwords in Spanish during our live demo at platan.us/hack/live.\n\nI wanted to take a moment to thank the organizers Rafael Fernández, Raimundo Herrera, Paula Enei, Platanus, our mentor Enzo Tamburini Heinz, the friendly staff at Fintual, and the team that made these two sleepless days memorable Alister MacCormack, Fernando Smith, Sergio A., Alejandro Grimminck.',
      reactionsCount: 141,
      commentsCount: 26,
      comments: [
        {
          authorName: 'Sebastián Breguel',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sergio A.',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Thomas Freund',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Jean Philipe Fuentes Bordagaray',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Felipe Mandiola',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Vicente Matus Ortiz',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Fernando Smith',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Alister MacCormack',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Francisco Wulf',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'María José Garrido Ureta',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 10,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQEW0oyLhrCwQg/feedshare-shrink_800/feedshare-shrink_800/0/1732746472933?e=2147483647&v=beta&t=4LVLK6rwDdJCRYbmoIk7EZAQ2cDDY01CR1IYITqtFT0',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 0,
          localFilename: 'post_image_1.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQEWU03SrtNxSw/feedshare-shrink_800/feedshare-shrink_800/0/1732746472779?e=2147483647&v=beta&t=GhRM9L41hTrgcbMlT8_PlkVAO2XqwNwbH7Wf6a5tZuQ',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 1,
          localFilename: 'post_image_2.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQFWMKEqXcu6Vg/feedshare-shrink_800/feedshare-shrink_800/0/1732746472859?e=2147483647&v=beta&t=5w03-QtO_OVc_pRevJHlNOOQRS5Makv9nOCr-eDJ3Hw',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 2,
          localFilename: 'post_image_3.png',
        },
      ],
      totalPostImages: 3,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [
        'nicolsberrios_1.png',
        'nicolsberrios_2.png',
        'nicolsberrios_3.png',
      ],
    },
    directoryName:
      'nicols_berrios_we_built_a_security_product_in_36_hours_and_won_th_2025-08-26T19-36-50-732Z',
  },
  {
    url: 'https://www.linkedin.com/posts/diegocostar_lo-logramos-primer-lugar-participamos-activity-7267716066976350210-HzGp?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:37:09.144Z',
    postData: {
      authorName: 'Diego Costa Reszczynski',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQGuczMU6gvOMg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1718812788742?e=2147483647&v=beta&t=FTwhEl5QGvkOGSw85N3X0hwaoG-sJ8yUQHZfSwc94vI',
      authorProfileUrl:
        'https://cl.linkedin.com/in/diegocostar?trk=public_post_feed-actor-image',
      authorJobTitle:
        'Ingeniero Civil Industrial - Diploma en Tecnologías de la información @ UC Chile',
      timePosted: '9mo',
      postContent:
        '¡LO LOGRAMOS! ¡PRIMER LUGAR! 🏆\nParticipamos en la Hackathon de Platanus,\n\nEn solo 36 horas, pasamos de tener una idea en un Miro a un producto funcional. Fue un desafío super intenso, pero una increíble oportunidad para aprender, crecer y rodearnos de personas excepcionales. Este ha sido mi tercer evento de este tipo este año, y cada uno ha sido una experiencia increíble! El ambiente único que se genera es realmente mágico ✨\n\nNuestro equipo, conformado por Cristián Villanueva Massardo, Alejandro Plaza Carrasco,Nicolas Olmos y Ignacio Muñoz Repetto, demostró una increíble capacidad de trabajo en equipo, cuidado y talento puro 😍. Todos desempeñaron sus roles con una eficiencia y atención al detalle admirable para crear Little Dragons!🐉. Una plataforma de educación financiera, diseñada para que los niños aprendieran a ahorrar, gastar responsablemente y ganar recompensas cumpliendo tareas. El proyecto incorporó la creación de dragones virtuales, con minijuegos y la posibilidad de personalizarlos, incluyendo accesorios que dibujé con algunos de los auspiciadores del evento. Pueden ver nuestra presentación en platan.us/hack/live (1:09:13)\n\nUn agradecimiento gigantesco a Ignacio Soffia, Angelo López Espíndola y Isabella Dabed quienes nos dieron consejos extremadamente útiles y nos ayudaron a pulir nuestra idea para llevarla al siguiente nivel.\nUn eterno agradecimiento a los organizadores Rafael Fernández, Raimundo Herrera, Paula Enei, Platanus, por hacer posible este evento tan bien organizado. A todos los auspiciadores como Fintual mi querido Buk 💙, Amazon Web Services (AWS) y Ria Money Transfer.',
      reactionsCount: 97,
      commentsCount: 15,
      comments: [
        {
          authorName: 'Maite Estay Casanova',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'DAFNE ARRIAGADA',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Benjamín Vicente Goecke',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Vicente Matus Ortiz',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Catalina Paz Caamaño Dubó',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Alejandro Núñez Arroyo',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Buk',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Trinidad Mesa Bozzolo',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sebastián Costa Valdebenito',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Isabella Dabed',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 10,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQFDtDsE2C6CCQ/feedshare-shrink_800/feedshare-shrink_800/0/1732758536241?e=2147483647&v=beta&t=kpobaXaDfNp56CYGwmod1qfry72Zs6lPpDF_LLEjjFo',
          alt: 'El grupo de ganadores de nuestro equipo posando juntos después de recibir el premio al primer lugar en la competencia.',
          width: 800,
          height: 533,
          index: 0,
          localFilename: 'post_image_1.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQGCSYNPOjPH0g/feedshare-shrink_800/feedshare-shrink_800/0/1732758535635?e=2147483647&v=beta&t=ByQ2-DG1bC14YTzmOyDMpSkv6capjzHEKCjH2FtsD2c',
          alt: 'El equipo de Little Dragons celebrando y enterándose de que hemos conseguido el primer lugar, mostrando reacciones de alegría y sorpresa.',
          width: 800,
          height: 533,
          index: 1,
          localFilename: 'post_image_2.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQHx6mKtRbRYNQ/feedshare-shrink_800/feedshare-shrink_800/0/1732758534776?e=2147483647&v=beta&t=8y8v7NcDQGR7nh2nQxm2qQ5l5WOvwETBZlDQ_MZs5oM',
          alt: 'Foto grupal con todos los equipos ganadores de las diferentes categorías, posando juntos en el evento de premiación.',
          width: 800,
          height: 533,
          index: 2,
          localFilename: 'post_image_3.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQEsMJi1eg-xrQ/feedshare-shrink_800/feedshare-shrink_800/0/1732758535777?e=2147483647&v=beta&t=ReTJhRGT2Eyi-F53-c-0ZePVugQgRWpkWGVzokEMxvI',
          alt: 'Foto grupal durante la hackathon de Platanus.',
          width: 800,
          height: 533,
          index: 3,
          localFilename: 'post_image_4.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/C4D0BAQE1RGvLNLEMVw/company-logo_100_100/company-logo_100_100/0/1654208135608/buk_cl_logo?e=2147483647&v=beta&t=9sdejztAZMLi14iSY7-4-sbqW-3EFJGP5SDPWoDJQBU',
          alt: 'Buk, graphic',
          width: 100,
          height: 100,
          index: 4,
          localFilename: 'post_image_5.png',
        },
      ],
      totalPostImages: 5,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [
        'diegocosta_1.png',
        'diegocosta_2.png',
        'diegocosta_3.png',
        'diegocosta_4.png',
        'diegocosta_5.png',
      ],
    },
    directoryName:
      'diego_costa_reszczynski_ingeniero_civil_industrial_-_diploma_en_tecnologa_2025-08-26T19-37-09-152Z',
  },
  {
    url: 'https://www.linkedin.com/posts/a-maccormack_de-cero-a-producto-en-36-horas-este-fin-activity-7267892568309301248-Hypp?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:37:27.825Z',
    postData: {
      authorName: 'Alister MacCormack',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQGygFgxO4hVUQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1688010114367?e=2147483647&v=beta&t=uiA5WA59VH7AQoqjL157eDxOiJvn5Fxb1bX_MJzCgJw',
      authorProfileUrl:
        'https://cl.linkedin.com/in/a-maccormack?trk=public_post_feed-actor-image',
      authorJobTitle: 'SWE @ Shinkansen',
      timePosted: '9mo',
      postContent:
        'De cero a producto en 36 horas.\n\nEste fin de semana tuve la oportunidad de participar en la primera edición de Platanus Hack. Obtuvimos el primer lugar en el track de Tecnología. No fue fácil, pero el equipo indicado hizo toda la diferencia:\n\n- Fernando Smith\n- Nicolás Berrios\n- Sergio A.\n- Alejandro Grimminck\n\nCreamos Anomala (https://anomala.cc), un sistema que detecta hackers en tu sitio en tiempo real y los bloquea de manera preventiva antes de que puedan cometer acciones maliciosas. \n\nCon un simple one-liner, tu sitio también podría quedar protegido de los intentos de hackers. \n\nY lo mejor de todo es que es opensource:\nhttps://lnkd.in/erExmqzE\n\nPueden ver el pitch en el siguiente link, donde Nico demuestra el funcionamiento de Anomala en vivo en el sitio de Fintual: \nhttps://lnkd.in/esUzZJez\n\nMuchas gracias a los organizadores: Rafael Fernández, Raimundo Herrera, Paula Enei de Platanus y a Fintual por ponerse con la sede del evento (y tomarse con humor nuestro demo).\n\nSi es que siguen teniendo sus dudas al respecto, pueden poner nuestro sistema a prueba e intentar de hackearlo en el siguiente link:\nhttps://lnkd.in/emj57MsX\n\nAgradecimientos especiales a Manu Ruibal por todas las fotos y al equipo de GourmetAP (https://lnkd.in/e_22a63H) por su comida de primer nivel.',
      reactionsCount: 75,
      commentsCount: 11,
      comments: [
        {
          authorName: 'Francisco Wulf',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sergio A.',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sebastián Passi Muñoz',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Benjamín Vicente Goecke',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Fernando Smith',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Diego Moers',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Matias Barrionuevo',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Nicolás Berrios',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Nicolas Gutierrez Seelenberger',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Efrén Rojas',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 10,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQFsboJoj69-7w/feedshare-shrink_800/feedshare-shrink_800/0/1732750782056?e=2147483647&v=beta&t=9jNCdHPpxrzkxTTbS9TtIbANDNPl9D-K_wkLJobFUhM',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 0,
          localFilename: 'post_image_1.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQGQtIFLFRFb4g/feedshare-shrink_800/feedshare-shrink_800/0/1732750782004?e=2147483647&v=beta&t=sTzR_nZMFPXRprbti8TADhp5u8GrxiTs6gdRJxNurtA',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 514,
          index: 1,
          localFilename: 'post_image_2.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQGD9v_ttMKeXw/feedshare-shrink_800/feedshare-shrink_800/0/1732750782028?e=2147483647&v=beta&t=UBdMdu1qtFMqxUBAlpL0HKuIgB8TF4QyJraUTXiacNU',
          alt: 'team con 2 horas de sueño',
          width: 800,
          height: 533,
          index: 2,
          localFilename: 'post_image_3.png',
        },
      ],
      totalPostImages: 3,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [
        'alistermaccormack_1.png',
        'alistermaccormack_2.png',
        'alistermaccormack_3.png',
      ],
    },
    directoryName:
      'alister_maccormack_de_cero_a_producto_en_36_horas_este_fin_de_seman_2025-08-26T19-37-27-833Z',
  },
  {
    url: 'https://www.linkedin.com/posts/joaquinfarfan_hackathon-innovaciaejn-tecnologaeda-activity-7267633753009582081-u0cC?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:37:46.190Z',
    postData: {
      authorName: 'Joaquin Farfan Torres',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQH2vJauJQe5Nw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1728401639861?e=2147483647&v=beta&t=BIwVzfkXphydA_QyfQIBi_2HDcpnr4mUyIhsCcyu2F8',
      authorProfileUrl:
        'https://cl.linkedin.com/in/joaquinfarfan?trk=public_post_feed-actor-image',
      authorJobTitle: 'Architect / IT Developer',
      timePosted:
        '9mo\n  \n                      \n                      \n                        Edited',
      postContent:
        '🎉 Este fin de semana fue pura creatividad, innovación y trabajo en equipo en el 🍌PLATANUS HACK, organizado por Platanus , Ria Money Transfer  y Fintual  🚀\n\nDurante dos días intensos, más de 120 mentes brillantes se reunieron para construir soluciones tecnológicas que enfrentaran desafíos reales. Desde la primera idea hasta el último pitch, vimos cómo la colaboración y la pasión por el desarrollo impactan de manera tangible.\n\n⚡️ Nuestro aporte:\nJunto a Claudio ☁️ Canales  y Seng Kitt Lee  \n\nCreamos FARO: \n\nUna aplicación y Extension de Chrome que usando IA (gracias OpenAI 🫶 ) identifica y bloquea enlaces maliciosos solucionando de una vez por todas las estafas de phishing.\n\n💡 Lo que aprendimos:\n\nEste hackathon nos recordó que las mejores ideas nacen cuando se juntan talentos diversos y objetivos compartidos. Fue una experiencia increíble ser testigos de cómo las ideas cobraban vida en tiempo récord.\n\nGracias a todos los participantes, organizadores y mentores que hicieron posible este evento!\n\n📌 ¿Quieres ser parte de la próxima edición? Atento a las redes de Platanus, esto recién comienza.\n\n\n#Hackathon #Innovación #Tecnología #Comunidad #platanushack #AWS\nBuk Fingo Pullpo (PV 23-1) Shinkansen EY Amazon Web Services (AWS)',
      reactionsCount: 12,
      commentsCount: 6,
      comments: [
        {
          authorName: 'Claudio Canales',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Fabio Soãres',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Francisco Catrileo',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Pau Andreu Koh Cuende',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Cristobal Oyarzun Astete',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 5,
      postImages: [],
      totalPostImages: 0,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [],
    },
    directoryName:
      'joaquin_farfan_torres__este_fin_de_semana_fue_pura_creatividad_innova_2025-08-26T19-37-46-197Z',
  },
  {
    url: 'https://www.linkedin.com/posts/fingomas_la-semana-pasada-tuvimos-el-agrado-de-ser-activity-7269819056226983939-f4S1?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:38:04.707Z',
    postData: {
      authorName: 'Fingo',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQE9_rYRdMgFBA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1711109633513?e=2147483647&v=beta&t=8zur4--t6bShk4PmOswzFjr7KhFBvPgkzGvFxzhq7HE',
      authorProfileUrl:
        'https://cl.linkedin.com/in/rvorellana?trk=public_post_comment_actor-image',
      authorJobTitle: 'Software & Product Engineer | SaaS | Fintechs',
      timePosted: '8mo',
      postContent:
        'La semana pasada tuvimos el agrado de ser Sponsor de la primera versión de Platanus Hack 🚀 🤯 , donde participaron 120 Ingenieros de Software, incluidos nuestros Devs 😎.\n\nEventos como este nos recuerdan cómo las Hackathons pueden ser un semillero de ideas innovadoras. Por ejemplo, los fundadores de Zapier, que crearon su primer prototipo en solo 36 horas en un Startup Weekend de la Universidad de Columbia. ¡La innovación puede surgir en cualquier momento! 💡 \n\nComo empresa, seguiremos apoyando y participando en estas iniciativas, ya que estamos convencidos de que son clave para fomentar nuevas soluciones y generar un impacto real 🤝 . Muchas gracias a Platanus y Fintual por la organización del evento.\n\nLes dejamos el Link para leer la nota completa https://lnkd.in/ehtzBU4q 🤓',
      reactionsCount: 66,
      commentsCount: 9,
      comments: [
        {
          authorName: 'Raimundo Orellana Litvak',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Patricio Lecaros Vial',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Agustina Vasquez Fuxs',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Javiera Irarrázaval Greene',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Vicente Molin',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Alberto Lamar Parra',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Diego Varas Domínguez',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Andrés Ignacio López Muñoz',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 8,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQGpbiZLgDabrQ/feedshare-shrink_800/feedshare-shrink_800/0/1733259922062?e=2147483647&v=beta&t=S-P8Z_LZ-SGYXF8phYDNzPmoqdH48p3nIQFkunWUWJo',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 0,
          localFilename: 'post_image_1.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQHCcpbDFaNS6w/feedshare-shrink_800/feedshare-shrink_800/0/1733259922314?e=2147483647&v=beta&t=3_P4ciLfQJtMZRMvoHqGlD8XyR2BgL4-tgCpDXKzdeg',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 1,
          localFilename: 'post_image_2.png',
        },
        {
          url: 'https://static.licdn.com/aero-v1/sc/h/921ynb2z53z33mhm3061qvjag',
          alt: 'No alternative text description for this image',
          width: 56,
          height: 56,
          index: 2,
          localFilename: 'post_image_3.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQE0J7fL5yN30g/feedshare-shrink_800/feedshare-shrink_800/0/1733259922023?e=2147483647&v=beta&t=SJOpFZtP99XRz3j_vGFgk5pHkSvoGAhgDE0eW_fRqns',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 3,
          localFilename: 'post_image_4.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E0BAQG6g0juelb1EQ/company-logo_100_100/company-logo_100_100/0/1731681782908/fingomas_logo?e=2147483647&v=beta&t=pHtGua9ALJuOT9kj5c4wbzAlygtEMZBoVQMCronXjxc',
          alt: 'View organization page for Fingo',
          width: 100,
          height: 100,
          index: 4,
          localFilename: 'post_image_5.png',
        },
      ],
      totalPostImages: 5,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [
        'fingo_1.png',
        'fingo_2.png',
        'fingo_4.png',
        'fingo_5.png',
      ],
    },
    directoryName:
      'fingo_la_semana_pasada_tuvimos_el_agrado_de_ser_sponsor__2025-08-26T19-38-04-711Z',
  },
  {
    url: 'https://www.linkedin.com/posts/daviddiaztunjano_hackathon-ai-activity-7268290912949096448-ch0t?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:38:23.733Z',
    postData: {
      authorName: 'David Díaz Tunjano',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/C4E03AQFjAXC_wLLhpg/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1660234153179?e=1759968000&v=beta&t=0CG3iP1bVjnBug0le2OfEW5gOQ0v5ICgwWbi1IYKCyE',
      authorProfileUrl:
        'https://cl.linkedin.com/in/daviddiaztunjano?trk=public_post_feed-actor-image',
      authorJobTitle: 'Lead AI Software Engineer @ ConsiliumBots',
      timePosted:
        '9mo\n  \n                      \n                      \n                        Edited',
      postContent:
        '🍌 Platanus Hackathon: 36 horas para construir un producto 🤯\n\nEl fin de semana pasado participé en mi primera hackathon! El equipo de Platanus Ventures organizó una instancia de lujo para resolver una problemática en educación, salud, tecnología para devs o finanzas. \n\nDesarrollamos hereda.me, una plataforma donde fomentamos la estimulación cognitiva de pacientes con Alzheimer mediante la invitación a contar sus experiencias y recuerdos para que queden como un regalo para toda la familia. \n\nBuscamos que fuera muy simple: \n1. Ingresar a la plataforma y elegir una pregunta para responder. Por ejemplo: “cuéntame un recuerdo que no olvidarás de tu infancia”\n\n2. Permitir acceso al micrófono y hablar como si le estuvieras contando a un amigo. Te responderá en tiempo real siguiendo la conversación. \n\n3. Cuando termines de contar la historia, se envía y nosotros un video con imágenes que acompañen su relato. Así se conserva sus recuerdos para que la familia pueda tenerlos y se estimula cognitivamente al paciente. \n\n\nSi te interesa la tecnología detrás, te cuento un poquito más en detalle:\n0. Levantamos un front con Next.js y una API con FastAPI. \n1. Nos conectamos a Retell AI para manejar la respuesta con voz en tiempo real.\n2. Generamos escenas a partir del texto del relato con la API de ChatGPT\n3. Cada escena llevamos a imágenes usando AWS Titan en Bedrock. \n4. Nuestra API une cada sección del relato con su respectiva imagen para generar el video.\n\nFueron 36 horas de mucho aprendizaje y poquísimo sueño pero muy contento con el resultado. Además muy agradecido por la suerte de contar con un equipazo de primer nivel: Joaquín Muñoz López José Fredes Marcelo Ignacio Saldías González Vicente Merino Badiola Aprendí un montón de cada uno! \n\nMuchas gracias a nuestro mentor Andrés Matte! Por la paciencia, acompañamiento y conocimiento! \n\nY muchísimas gracias a Raimundo Herrera y Rafael Fernández por organizar este tremendo evento! Y a las empresas que permitieron que fuera posible: Platanus Amazon Web Services (AWS)  Fintual Buk Ria Money Transfer\n\nSi quieres usarla, ingresa al link y empieza a contar tu historia. En la sección “historial” podrás ver tu relato tras unos segundos. Si quieres conversar más sobre la tecnología detrás, hablemos!\n\n\n#hackathon #ai',
      reactionsCount: 48,
      commentsCount: 7,
      comments: [
        {
          authorName: 'Rafael Fernández',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Nicolás Berrios',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Jan Heinvirta',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Vicente Merino Badiola',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sergio A.',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Rafael Fernández',
          text: 'By clicking Continue to join or sign in, you agree to LinkedIn’s User Agreement, Privacy Policy, and Cookie Policy.',
          reactions: 1,
        },
        {
          authorName: 'José Fredes',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 7,
      postImages: [],
      totalPostImages: 0,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [],
    },
    directoryName:
      'david_daz_tunjano__platanus_hackathon_36_horas_para_construir_un__2025-08-26T19-38-23-738Z',
  },
  {
    url: 'https://www.linkedin.com/posts/antoniasanmartinsola_la-semana-pasada-fue-platanus-hack-day-en-activity-7267940097478508544-lgn7?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:38:42.374Z',
    postData: {
      authorName: 'Antonia San Martín Sola',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQGpmaHNh_aiOw/profile-displayphoto-shrink_400_400/B4EZWnNYEhHUAg-/0/1742267057380?e=2147483647&v=beta&t=gI3OQUVpZWmIrPKJy5xqV7rHHBUYhtacLIzRYQ5UKik',
      authorProfileUrl:
        'https://mx.linkedin.com/in/antoniasanmartinsola?trk=public_post_feed-actor-image',
      authorJobTitle:
        'Software Engineer | Escribo en nicomassardo.substack.com',
      timePosted:
        '9mo\n  \n                      \n                      \n                        Edited',
      postContent:
        'La semana pasada fue Platanus Hack Day en Fintual y 🤯. Ver tanta gente talentosa trabajando 36 horas todo para resolver problemas con AI muestra lo que se viene en los próximos años 💻\n\nEste país tiene todo para convertirse en el semillero de las próximas startups que van a cambiar la región. \n\nGracias a Platanus y Fintual por ser el espacio donde pasan estas cosas y en especial a este equipo de mentores✨.',
      reactionsCount: 200,
      commentsCount: 7,
      comments: [
        {
          authorName: 'Manu Ruibal',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Nicolas Massardo Tapia',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Ana. Maria Castilla Fernandez',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Pablo N. Arroyo From',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sergio A.',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'María José Díaz Vicente',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Fabián Acuña Hernández',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 7,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQHVP6H4RP-raA/feedshare-shrink_800/feedshare-shrink_800/0/1732811950279?e=2147483647&v=beta&t=oOzb3zlIyJ7bEG5tJn0787oqC1UV918YM2SGaszA_qc',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 0,
          localFilename: 'post_image_1.png',
        },
      ],
      totalPostImages: 1,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: ['antoniasan_1.png'],
    },
    directoryName:
      'antonia_san_martn_sola_la_semana_pasada_fue_platanus_hack_day_en_fintual__2025-08-26T19-38-42-379Z',
  },
  {
    url: 'https://www.linkedin.com/posts/catalina-vicu%C3%B1a-silva-301803334_el-fin-de-semana-pasado-tuve-la-oportunidad-activity-7269376116056801280-04i2?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:39:00.782Z',
    postData: {
      authorName: 'Catalina Vicuña Silva',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQExHCe2E0v8HQ/profile-displayphoto-scale_100_100/B4EZfQUFJXHIAc-/0/1751546615623?e=1759968000&v=beta&t=ZMw8hxuXoVG0I8pJ7-FGj3-_Ev2JKHPBH7PBWrICcB8',
      authorProfileUrl:
        'https://cl.linkedin.com/in/catalina-vicu%C3%B1a-silva-301803334?trk=public_post_feed-actor-image',
      authorJobTitle: 'Periodista',
      timePosted:
        '8mo\n  \n                      \n                      \n                        Edited',
      postContent:
        'El fin de semana pasado tuve la oportunidad de ir a la Platanus Hack, una hackatón de 36 horas en la que participaron 120 personas muy motivadas y apasionadas por la tecnología.\n\nLos invito a leer una breve crónica que escribí para el DFMAS sobre el evento.\n\n(Link en los comentarios)',
      reactionsCount: 31,
      commentsCount: 5,
      comments: [
        {
          authorName: 'Fernando Smith',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Paula Enei',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sergio A.',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 3,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQHsVO4r-ktWvA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1733154323052?e=2147483647&v=beta&t=vlqFuwRXDcxgx3beYkloQRunKHm6A_mQc9Zv4xce0Wg',
          alt: 'No alternative text description for this image',
          width: 960,
          height: 1262,
          index: 0,
          localFilename: 'post_image_1.png',
        },
      ],
      totalPostImages: 1,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: ['catalinavicua_1.png'],
    },
    directoryName:
      'catalina_vicua_silva_el_fin_de_semana_pasado_tuve_la_oportunidad_de_ir__2025-08-26T19-39-00-786Z',
  },
  {
    url: 'https://www.linkedin.com/posts/vgonzalezfuentes_en-noviembre-tuve-la-oportunidad-de-participar-activity-7280716324962504705-o5zy?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:39:19.704Z',
    postData: {
      authorName: 'Valentina Gonzalez Fuentes',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQGSerfUmtlH6w/profile-displayphoto-scale_100_100/B4EZjzEdggHoAc-/0/1756424691926?e=1759968000&v=beta&t=e35q0Dw0_-E-1K2N4WzmYAtciafUUX89KoV6AfceXR4',
      authorProfileUrl:
        'https://cl.linkedin.com/in/vgonzalezfuentes?trk=public_post_feed-actor-image',
      authorJobTitle: 'Senior Software Engineer en MACH',
      timePosted: '7mo',
      postContent:
        'En noviembre, tuve la oportunidad de participar en la hackatón de Platanus, cuyo desafío consistía en desarrollar un producto desde cero en tan solo 36 horas. Fue una experiencia profundamente inspiradora y enriquecedora, en la que más de 120 personas trabajaron para crear aplicaciones relacionadas con los tracks de finanzas, tecnología, educación y salud.\n\nNuestro equipo decidió desarrollar Mateo-IA, una aplicación educativa enfocada en ayudar a resolver problemas matemáticos de la PAES utilizando inteligencia artificial. El trabajo en equipo y la distribución estratégica de tareas (y dormir un poco menos) nos permitió lograr un MVP en tan poco tiempo.\n\nQuiero reconocer y agradecer la motivación y el compromiso de mi equipo, así como el esfuerzo de la organización de Platanus  que hizo posible este evento.\n\nGabriela Mendoza Muñoz \nMaximiliano Vargas \nJuan Jiménez Sieber \nPatricio Alejandro Gutierrez Lopez',
      reactionsCount: 98,
      commentsCount: 10,
      comments: [
        {
          authorName: 'Gabriela Mendoza Muñoz',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Maximiliano Vargas',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Juan Jiménez Sieber',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Vania Schatloff Valenzuela',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Marcelo Becerra Alarcón',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Patricio Alejandro Gutierrez Lopez',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Catalina Rojas Saldías',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Felipe González Merino',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Matías I. Rodríguez Morán',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sarah Everke',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 10,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQF0OVJGmD7Fvg/feedshare-shrink_800/B4EZQpM529HEAk-/0/1735858038868?e=2147483647&v=beta&t=2OzK-JvR91VXky1rdzmD-9ccLUfZkMSB3XWj1x73qg0',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 600,
          index: 0,
          localFilename: 'post_image_1.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQE3NTfpVElODQ/feedshare-shrink_2048_1536/B4EZQpM53MGwAo-/0/1735858038607?e=2147483647&v=beta&t=psLj4Wl36GWU8qESRc-g0kxyaB_nmzO6aAtRuqs4h_Y',
          alt: 'No alternative text description for this image',
          width: 1152,
          height: 1536,
          index: 1,
          localFilename: 'post_image_2.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQHiLhfS90mOZg/feedshare-shrink_800/B4EZQpM53UHEAg-/0/1735858038290?e=2147483647&v=beta&t=hsljVfZdx7fqj3VVpLgX6mmPG8M_l4qewD7zwEFUjMc',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 2,
          localFilename: 'post_image_3.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQH-BGHjs-0fTA/feedshare-shrink_800/B4EZQpM53kHgAg-/0/1735858038195?e=2147483647&v=beta&t=gmRIlmyp50fO7D02GAZM85Axg6rumnmTw7JxkzKjDYA',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 3,
          localFilename: 'post_image_4.png',
        },
      ],
      totalPostImages: 4,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [
        'valentinagonzalez_1.png',
        'valentinagonzalez_2.png',
        'valentinagonzalez_3.png',
        'valentinagonzalez_4.png',
      ],
    },
    directoryName:
      'valentina_gonzalez_fuentes_en_noviembre_tuve_la_oportunidad_de_participar_en_2025-08-26T19-39-19-713Z',
  },
  {
    url: 'https://www.linkedin.com/posts/tomas-cortes-de-la-fuente_fuimos-a-la-hackat%C3%B3n-platanus-con-mat%C3%ADas-activity-7272423981574455296-5hlj?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:39:38.418Z',
    postData: {
      authorName: 'Tomas Cortes de la Fuente',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/C4D03AQGVsbEMJn-1Hw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1629070862803?e=2147483647&v=beta&t=6YFLdmdNK5TAWBzDLSQWUV-_tPKTa-R7YegngqYf-LQ',
      authorProfileUrl:
        'https://cl.linkedin.com/in/tomas-cortes-de-la-fuente?trk=public_post_feed-actor-image',
      authorJobTitle: 'software-engineer',
      timePosted:
        '8mo\n  \n                      \n                      \n                        Edited',
      postContent:
        'Fuimos a la hackatón Platanus con Matías Ovalle Prat Gabriel Faúndez Soto y Cristobal Ilabaca Velasco\n\n"De cero a producto en 36 horas"\n\nLo que más nos motivó fue que no tenía que ser rentable ni vendible 💸. Lo que nos dio la libertad de hacer algo que nadie haya creado 🚀.\n\nFue una experiencia increíble 🙌🙌. \nEn solo las primeras 4 horas fallamos como 20 veces tratando de levantar React Native, Flutter y Android Studio para un APK que leyera notificaciones 💀 (No funcionó, pero Mati encontró una app que ya lo hacía 😶🌫️).\n\nDespués de todo esto, creamos mind-sift 🧠, un sistema para filtrar notificaciones basadas en categorizaciones definidas por texto. \nResuelve el gran problema de que para filtrar notificaciones, o apagas todo. O estas bombardeado todo el día por globos de notificación.\n\n¡Salimos 3ros en la categoría de salud! 🥉\n\nMuchísimas gracias a Platanus y al gran Rafael Fernández por esta instancia 🙏🙏. Salí feliz y con más ganas que nunca de seguir programando 😄.\n\nPor si quieren darle una mirada a la presentación, aquí está el proyecto: https://lnkd.in/ethdxnk5',
      reactionsCount: 102,
      commentsCount: 6,
      comments: [
        {
          authorName: 'Yoser Mizael Godoy Carrasco',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Max Levill - Revenew - Revenue Optimization SaaS',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Leonella Navas',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Benjamín Delpiano Torrealba',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Lorena De La Fuente',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Piero Falcone Said',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 6,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQE4IjtTCqGPSg/feedshare-shrink_800/B4EZOzXET4HAAg-/0/1733880990401?e=2147483647&v=beta&t=1HXv3JzdK3Mz2bR7Kf5ybbx2j6mk7lIUNpO2i6Lubic',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 449,
          index: 0,
          localFilename: 'post_image_1.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQEp-5Rn2c4Y_g/feedshare-shrink_800/B4EZOzXETwH0Ag-/0/1733880990946?e=2147483647&v=beta&t=Lc7x9rWGQs-wPNQThmbXYHTqNEAPfhDHaOjGWEpujV8',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 1,
          localFilename: 'post_image_2.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQE9CUavt3RwcA/feedshare-shrink_800/B4EZOzXETnHEAg-/0/1733880990516?e=2147483647&v=beta&t=D-MKsvU45Uz40LHIor4_4JJKhGKfvWzRQGbWgfldIQQ',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 2,
          localFilename: 'post_image_3.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQGg6YXqHlNUqw/feedshare-shrink_2048_1536/B4EZOzXET3HkAo-/0/1733880990205?e=2147483647&v=beta&t=lJKbhihinHN9M-EIQS9G7FBkKHaVzbUguzzpsKg3_T0',
          alt: 'No alternative text description for this image',
          width: 1023,
          height: 1536,
          index: 3,
          localFilename: 'post_image_4.png',
        },
      ],
      totalPostImages: 4,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [
        'tomascortes_1.png',
        'tomascortes_2.png',
        'tomascortes_3.png',
        'tomascortes_4.png',
      ],
    },
    directoryName:
      'tomas_cortes_de_la_fuente_fuimos_a_la_hackatn_platanus_con_matas_ovalle_pr_2025-08-26T19-39-38-421Z',
  },
  {
    url: 'https://www.linkedin.com/posts/hsufan_ganamos-la-hackaton-organizada-por-platanus-activity-7268957031238184960-SmNA?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:40:12.618Z',
    postData: {
      authorName: 'Hussam Sufan',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQHxWL2qMTErZg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1718420656888?e=2147483647&v=beta&t=8CzXZKprjLh80E6k15vOjAZfBWj0MD87jZDJcLQQrYg',
      authorProfileUrl:
        'https://cl.linkedin.com/in/hsufan?trk=public_post_feed-actor-image',
      authorJobTitle:
        'I help organizations get paid and make more money. Every month. CEO @Reveniu.',
      timePosted: '8mo',
      postContent:
        '🥳 Ganamos la hackaton organizada por Platanus Fintual Buk y otros partners. \n\nConstruimos un producto financiero en 36 horas 🤯 junto con Jaime, Cristopher Galarce y Santiago llamado Kairos. \n\nKairos te permite analizar tus estados de cuenta de tu tarjeta de crédito en lenguaje humano, para que evites pagar intereses extras y sepas en qué estás gastando tu dinero.\n\nHoy necesito tu apoyo para que ganemos un segundo premio 💪\n\nVotación del público:\n\n1️⃣ Ingresa a este link https://lnkd.in/esVwF4Yp\n\n2️⃣ Si te gusta el proyecto, presiona en la flecha que hay hacia arriba ⬆️\n\n3️⃣ Hoy en la noche recibirás el detalle de todo lo que vivimos en las 36 horas que duró esta maratón. Suscríbete para que te llegue aquí: https://huss.substack.com/ \n\nPrometo que te contaré todos los detalles de esta gran aventura que vivimos, la cual ganamos 🥳\n\nAhora, a votar 🚀 Y después aprovecha de ver también los otros proyectos que están increíbles. Gente muy talentosa construyó cosas épicas en tiempo record.',
      reactionsCount: 239,
      commentsCount: 47,
      comments: [
        {
          authorName: 'Ana Fernández',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Miguel Paz',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Francisco Marshall',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Felipe López Miranda',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Carolina Sufán Soto',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Vicente Donoso Rodríguez',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Juan Andrés Bravo',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Manu Ruibal',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Yuval Shats',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Alfredo Sarria',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 10,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQEet7O-VP5pkA/feedshare-shrink_800/feedshare-shrink_800/0/1733013310528?e=2147483647&v=beta&t=_ZlLGpE8lwGsoWUPD0ETaLRW46vHkfd7-aW3zozRL9Y',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 449,
          index: 0,
          localFilename: 'post_image_1.png',
        },
      ],
      totalPostImages: 1,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: ['hussamsufan_1.png'],
    },
    directoryName:
      'hussam_sufan__ganamos_la_hackaton_organizada_por_platanus_fin_2025-08-26T19-40-12-626Z',
  },
  {
    url: 'https://www.linkedin.com/posts/pedrocisternas_de-cero-a-producto-en-36-horas-nuestra-activity-7267707813097783296-WLAr?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:40:32.061Z',
    postData: {
      authorName: 'Pedro Cisternas',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQFutQthLnLi0w/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1722627199017?e=2147483647&v=beta&t=i1soFbwM3VkgEM_AS5Rqn55ic0aXyBaWfYmnkWOEMYQ',
      authorProfileUrl:
        'https://cl.linkedin.com/in/pedrocisternas?trk=public_post_feed-actor-image',
      authorJobTitle:
        'Ingeniero de Software de la Pontificia Universidad Católica',
      timePosted:
        '9mo\n  \n                      \n                      \n                        Edited',
      postContent:
        '💻☕ | De Cero a Producto en 36 Horas: Nuestra Primera Hackathon\n\nEste fin de semana fue una locura. 36 horas de pura concentración, poco sueño y mucho café para crear un producto desde cero en nuestra primera hackathon, organizada por Platanus. ¿El objetivo? Resolver un problema real usando tecnología.\n\nPodíamos elegir entre cuatro temas: salud, finanzas, educación y tecnología. Optamos por salud, profundizando en el área de salud mental, con el propósito de abordar un problema claro: a muchas personas les falta autoconocimiento. \n\nAsí nació Yournal, una app que combina journaling con inteligencia artificial. Es simple: hablas, escribes o mandas un audio contando tu día, y la app analiza todo para identificar qué cosas te hacen bien, cuáles no, y cómo mejorar la forma en la que hablas contigo mismo. Mientras más inputs le das, mejores recomendaciones y análisis vas obteniendo.\n\n¿Qué logramos?\n\n- Un prototipo funcional que utiliza inteligencia artificial para descomponer emociones y generar patrones con una base de datos vectorial, permitiendo recomendaciones personalizadas.\n- Un pitch sólido en el que logramos transmitir el valor de nuestra solución.\n- Conocimos a fundadores de startups y cracks del mundo del emprendimiento.\n- Aprendimos muchísimo sobre trabajo en equipo, desarrollo bajo presión y cómo llevar una idea desde cero hasta algo funcional en tiempo récord.\n\nEl equipo:\nMatías Concha y yo en el backend y la implementación de la IA (donde aprendí muchísimo sobre el uso de vectores, que son representaciones numéricas que nos permitieron identificar patrones entre actividades y emociones). Nicolas Pirozzi lideró el desarrollo del frontend, y Felipe Mandiola se dedicó al 100% al diseño UX/UI, creando una experiencia de usuario tremenda.\n\nNo todo salió perfecto (la demo tuvo problemas técnicos 🙃), pero nos quedamos con grandes aprendizajes y la satisfacción de haber construido algo tan pro en tan poco tiempo.\n\nAhora, queremos llevar esta idea un poco más allá. Mejorar la app, pulir algunos detalles y, quién sabe, llevarla a la App Store y Play Store. \n\nA seguir creando!!! 🚀\n\n(Les dejo el link de nuestro pitch/demo. Desde el minuto 3:35:20:\nhttps://lnkd.in/e4mufaXV)\n\nFotos de Manu Ruibal',
      reactionsCount: 174,
      commentsCount: 15,
      comments: [
        {
          authorName: 'Manu Ruibal',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Felipe Mandiola',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Matías Concha',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Luis Loaiza',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Gonzalo Pineda',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'David Alvarez Barraza',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Cristóbal Pesqueira',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sebastián Rivera Escobar',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Sebastián Passi Muñoz',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Martín Dupré Riveros',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 10,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQG3k6iW8ypP0g/feedshare-shrink_800/feedshare-shrink_800/0/1732756565690?e=2147483647&v=beta&t=YG4z1ihBjnYIllXjgyZq1290pg1ZF3W-4skb38Mq5EI',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 0,
          localFilename: 'post_image_1.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQE4GB4QOdGehg/feedshare-shrink_800/feedshare-shrink_800/0/1732756567977?e=2147483647&v=beta&t=_SS4TSyyCcFwqqc7q8BEvUK6h8HZ-swL1UpxmO3S0eg',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 1,
          localFilename: 'post_image_2.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQHTfwlPolUO5w/feedshare-shrink_1280/feedshare-shrink_1280/0/1732756562211?e=2147483647&v=beta&t=WQHpnxGyRN71nhIitxhYhVrdyrLo4NyOA-mqPDyAS9Q',
          alt: 'No alternative text description for this image',
          width: 870,
          height: 1876,
          index: 2,
          localFilename: 'post_image_3.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQEioxv3ZlZR_A/feedshare-shrink_1280/feedshare-shrink_1280/0/1732756562048?e=2147483647&v=beta&t=uUggVIy0i1x8LnK5J_HR_fz_o0iyvh1xO8Db7inopes',
          alt: 'No alternative text description for this image',
          width: 874,
          height: 1904,
          index: 3,
          localFilename: 'post_image_4.png',
        },
      ],
      totalPostImages: 4,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [
        'pedrocisternas_1.png',
        'pedrocisternas_2.png',
        'pedrocisternas_3.png',
        'pedrocisternas_4.png',
      ],
    },
    directoryName:
      'pedro_cisternas__de_cero_a_producto_en_36_horas_nuestra_prim_2025-08-26T19-40-32-066Z',
  },
  {
    url: 'https://www.linkedin.com/posts/matiascoxedwards_mi-primera-hackathon-c%C3%B3mo-cagarla-f%C3%A1cil-activity-7267611068519133186-9Eca?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:40:50.579Z',
    postData: {
      authorName: 'Matias Cox Edwards',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D4E03AQGG9N4yxJ55-A/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1727055677893?e=2147483647&v=beta&t=aXuEjQLiC9gvZdg-XNqPozMojxwORBihvqGo3_YiHe8',
      authorProfileUrl:
        'https://cl.linkedin.com/in/matiascoxedwards?trk=public_post_feed-actor-image',
      authorJobTitle: 'Software Engineer - Ingeniero Civil Industrial',
      timePosted:
        '9mo\n  \n                      \n                      \n                        Edited',
      postContent:
        'El fin de semana pasado estuvimos participando de la hackathon de Platanus en las oficinas de Fintual. (equipo de hackers: Hernán Macaya, Agustín Berguecio, LUCAS VAN SINT JAN CAMPOS). Fueron 36 horas para desarrollar un producto funcional desde cero.\n\nDesarrollamos meayudAI, un asistente de IA que le permite a los profesores corregir exámenes escritos a manos, según sus propios criterios y pautas. \nNuestro objetivo era, por un lado, aliviar la carga de los docentes, evitando que tengan que dedicar horas de su tiempo libre a corregir decenas de pruebas durante el fin de semana. Por otro lado, digitalizar los datos de cada evaluación, abre una puerta enorme para ofrecer herramientas de seguimiento personalizado del progreso de cada estudiante, facilitando la personalización de la educación. \nCreemos que esta personalización según cada alumno, ya sea por sus interés y/o habilidades, representa uno de los grandes desafíos de nuestra generación en el ámbito educativo.\n\nEscribí un post sobre cómo fue la experiencia, anécdotas y consejos por si estás pensando en participar en tu primera hackathon!\n\nhttps://lnkd.in/es8HyhBT\n\nPD: Si eres profesor/a y te interesa acceder a las primeras versiones de meayudAI, y ayudarnos a construir un mejor producto, envíame un DM!',
      reactionsCount: 62,
      commentsCount: 18,
      comments: [
        {
          authorName: 'Agustin Gomez Campero',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Nicolás Berrios',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Josefa Paz España Herrera',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Magdalena Cancino',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Manuel Díaz Vergara',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Marco Gómez',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Miguel Guerrero Irarrázaval',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Alfonso Edwards Chadwick',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
        {
          authorName: 'Pedro Fleischmann Chadwick',
          text: 'Agree & Join LinkedIn',
          reactions: 1,
        },
      ],
      totalVisibleComments: 9,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/sync/v2/D4E27AQHNxnHsbDf8tw/articleshare-shrink_1280_800/articleshare-shrink_1280_800/0/1753322135985?e=2147483647&v=beta&t=nX6Lhx3DdF1ax68bi-09UPA0vg00MhAWKsrjnua5l7E',
          alt: 'Mi primera hackathon: cómo cagarla fácil, tips y un poco más.',
          width: 1024,
          height: 768,
          index: 0,
          localFilename: 'post_image_1.png',
        },
      ],
      totalPostImages: 1,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: ['matiascox_1.png'],
    },
    directoryName:
      'matias_cox_edwards_el_fin_de_semana_pasado_estuvimos_participando_de__2025-08-26T19-40-50-586Z',
  },
  {
    url: 'https://www.linkedin.com/posts/huasito_si-no-duermo-8-horas-soy-miserable-preg%C3%BAntenle-activity-7267527553832161280-3ALo?utm_source=share&utm_medium=member_desktop&rcm=ACoAAC1OjVkB1A2vUCgASMLfE12nGSyB8i4EUiM',
    timestamp: '2025-08-26T19:41:09.956Z',
    postData: {
      authorName: 'Sergio A.',
      authorProfilePicture:
        'https://media.licdn.com/dms/image/v2/D5603AQGFXPAVlKXAaw/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1679678421596?e=1759968000&v=beta&t=3ocEYxLlyWh9O0fQ-AP2N40OkWfPP1kHRVTgo9dBKF4',
      authorProfileUrl:
        'https://cl.linkedin.com/in/huasito?trk=public_post_feed-actor-image',
      authorJobTitle:
        'Queriendo Construir cosas interesantes. Software Engineer en @Zerofox',
      timePosted:
        '9mo\n  \n                      \n                      \n                        Edited',
      postContent:
        'Si no duermo 8 horas soy miserable, pregúntenle a mi polola Isidora Rivera Jorquera\n\nEste finde tuve un total acumulado de 4 y ha sido de los mejores del año.\n\nQuiero partir con los kudos 🙌, qué tremenda organización se mandó Platanus, gracias por todo, al goat 🐐 Rafael Fernández y el tremendo team que tienen.\n\t•\tPaula Enei\n\t•\tRaimundo Herrera\n\t•\tJoaquin Stephens\n\t•\tJan Heinvirta.  \nEvento de primer nivel, creo todos los presentes nos fuimos con esa sensación de. La raja esta wea. Confío que se vienen más.\n\nGracias a Fintual, no solo por pasarnos la casa, por tenernos guaguitas con tremendas instalaciones, rellenitos con comida que hasta El LaMar envidia y por las Fantas, que mantuvieron el azúcar alto y permitieron rendir. Perdón por tomarme la última 😅. \n\nKudos a todos los mentores, que nos escucharon el crazy pitch que teníamos y nos dieron feedback, no se salvó ninguno de nosotros.\n\t•\tAndrés Matte\n\t•\tDaniel Pérez Rada\n\t•\tIgnacio Soffia\n\t•\tJan Heinvirta\n\t•\tMarisol Acuña\n\t•\tRaimundo Herrera\n\t•\tAgustin Gomez Campero\n\t•\tMaurice Poirrier\n\t•\tMontserrat Peralta\n\t•\tMilan Rafaeli\n& Special Enzo Tamburini Heinz por la entretenida cena que tuvimos  🍽️.\n\nBacán tener jueces de primer nivel, gracias por donarnos su domingo \n\t•\tSebastian Kreft\n\t•\tLeo Soto\n\t•\tAntonia San Martín Sola\n\t•\tPatricio López Juri\n\t•\tUgarte\n\nGracias a todos los equipos, fue la raja hablar con toda la gente, ver lo que armaban y el ambiente que se armó, conocí y compartí con un montón de gente genial, keep it up.  🚀\n\nGracias Manu Ruibal por las fotos,  ¡están 🔥🔥!\n\nLastly but most important, Los Boys 🕺\nGracias por adoptarme, por las risas, la esquizofrenia y estar Locked in.\n\n\t•\tAlister MacCormack   si necesitan un Pen tester  \n\t•\tFernando Smith Gokei (PV 23-2)  te facilita la salud\n\t•\tAlejandro Grimminck Master del Front\n\t•\tNicolás Berrios Pitch crusher\n\t•\tSebastián Breguel Best QA engineer there is\n\n¿Qué armamos en 36 horas? 🔒\n\nCreamos un detector de hackers en tiempo real. Es como si estuvieras viendo la pantalla de ellos todo el tiempo. Para que la gente como Alister MacCormack no te deje la cagada en tu sitio.\n\n\t•\tPuedes ver nuestra demo aquí: https://lnkd.in/e3myU2dC\n\n\t•\tIntenta hackearnos en nuestro propio Fintual  (activo hasta el viernes): https://lnkd.in/eQm8rirn. \n\t•\tEl paquete npm está disponible, pero úsalo bajo tu propio riesgo.\n\n\t•\t🚀 Próximamente: Enterprise Support 👀👀\n\nPueden ver todo lo que se construyo https://lnkd.in/eirgKCSx \nNosotros somos el equipo 13 BTW.\n\nFinal Stats:\n\t•\t🛌 4 horas de sueño acumulado\n\t•\t🍬 16 fantas o un total de 448 gr de azúcar (Sorry Andrew Huberman)\n\t•\t💻 9263 líneas de código\n\t•\t🗂️ 130 commits (me arrepiento de varios)\n\n\n-----------------------------------------------------------------------------\nEnglish Version 🇺🇸 on the comments\n-----------------------------------------------------------------------------',
      reactionsCount: 137,
      commentsCount: 19,
      comments: [
        {
          authorName: 'Nicolás Berrios',
          text: 'Agree & Join LinkedIn',
          reactions: 7,
        },
        {
          authorName: 'Fernando Smith',
          text: 'Agree & Join LinkedIn',
          reactions: 7,
        },
        {
          authorName: 'Nicolás Berrios',
          text: 'By clicking Continue to join or sign in, you agree to LinkedIn’s User Agreement, Privacy Policy, and Cookie Policy.',
          reactions: 7,
        },
        {
          authorName: 'Sophia Jander Palma',
          text: 'Agree & Join LinkedIn',
          reactions: 7,
        },
        {
          authorName: 'Jan Heinvirta',
          text: 'Agree & Join LinkedIn',
          reactions: 7,
        },
        {
          authorName: 'Marisol Acuña',
          text: 'Agree & Join LinkedIn',
          reactions: 7,
        },
        {
          authorName: 'Manu Ruibal',
          text: 'Agree & Join LinkedIn',
          reactions: 7,
        },
        {
          authorName: 'Maurice Poirrier',
          text: 'Agree & Join LinkedIn',
          reactions: 7,
        },
      ],
      totalVisibleComments: 8,
      postImages: [
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQHAlNISPMOv-A/feedshare-shrink_800/feedshare-shrink_800/0/1732713588384?e=2147483647&v=beta&t=JRO-xJcQ66_7_WNSpgX9hQi3gzxtRH3MsKIQT1Ir7Zg',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 0,
          localFilename: 'post_image_1.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQHDIXTUfnjBHg/feedshare-shrink_800/feedshare-shrink_800/0/1732713571837?e=2147483647&v=beta&t=I6yvksQEKgJEKRzTyBQCMNHsIpFYvFOtYR5XW8HjWoc',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 514,
          index: 1,
          localFilename: 'post_image_2.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQFAV4wWcLm1eQ/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1732713569803?e=2147483647&v=beta&t=BYSbg-X1We0Od2J-lmQPKCVZIU5IE_tvSCwsckFAXcs',
          alt: 'No alternative text description for this image',
          width: 1156,
          height: 868,
          index: 2,
          localFilename: 'post_image_3.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQGgoY2ah45YqQ/feedshare-shrink_800/feedshare-shrink_800/0/1732713572062?e=2147483647&v=beta&t=umGRF3z3O_LLOxJ6JdH72jrVb0_M8kQSnuUVqgpkR28',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 599,
          index: 3,
          localFilename: 'post_image_4.png',
        },
        {
          url: 'https://media.licdn.com/dms/image/v2/D4E22AQF7_iAIYPmy_w/feedshare-shrink_800/feedshare-shrink_800/0/1732713589188?e=2147483647&v=beta&t=_-GRvKULImDnuCzvXlKjRqP0K7YaAZ8w93oPgkq2zFs',
          alt: 'No alternative text description for this image',
          width: 800,
          height: 533,
          index: 4,
          localFilename: 'post_image_5.png',
        },
      ],
      totalPostImages: 5,
      authorProfilePictureLocal: 'profile_picture.jpg',
      newImageFilenames: [
        'sergioa_1.png',
        'sergioa_2.png',
        'sergioa_3.png',
        'sergioa_4.png',
        'sergioa_5.png',
      ],
    },
    directoryName:
      'sergio_a_si_no_duermo_8_horas_soy_miserable_pregntenle_a__2025-08-26T19-41-09-966Z',
  },
];
